


//main.style.height='50%'

var p=0;

const animate=()=>{
    const all=document.querySelectorAll('.product-ascii ')
    const main=all[0]

  if(p<100){
      p++
  }

  
    all.forEach(wrapper=>{
             wrapper.style.height=p+"%"
    })
  

      
    
 
}

setInterval(()=>{
  animate()
},50)
